import { render, staticRenderFns } from "./StoreBusinessImport.vue?vue&type=template&id=f59a4976&scoped=true"
import script from "./StoreBusinessImport.vue?vue&type=script&lang=js"
export * from "./StoreBusinessImport.vue?vue&type=script&lang=js"
import style0 from "./StoreBusinessImport.vue?vue&type=style&index=0&id=f59a4976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a4976",
  null
  
)

export default component.exports